// Какие уведомления мобильное приложение не показывает.
//
// Подписки и маркетинг (скидки, предложения тарифов) — про то, что продаётся
// на сайте. В приложении покупок нет, и App Store читает такое уведомление как
// «контент, купленный вне приложения» (3.1.1, отказ StudyHub 1.1.1 (9)
// 02.11.2026). Вкладку «Оплата» прятали и раньше, но те же записи оставались
// во вкладке «Все» и всплывали тостом.
//
// Одно правило на ленту и на тосты — иначе одно из мест забудут.

import { IS_CAPACITOR } from "@/lib/platform-detect";

const APP_HIDDEN_TYPES: ReadonlySet<string> = new Set(["subscription_alert", "marketing"]);

/** `true` — уведомление этого типа на текущей поверхности не показываем. */
export function isNotificationHiddenOnSurface(type: string): boolean {
	return IS_CAPACITOR && APP_HIDDEN_TYPES.has(type);
}
